import React from 'react'
import Affilate_1 from '../../../assets/images/home_page_4/affiliate/01.png'

const Affilate = () => {
    return (
        <>
            <section id="affiliate" className="affiliate-main-block">
                <div className="container">
                    <div className="affiliate-block">
                        <div className="row">
                            <div className="col-lg-5">
                                <div className="affiliate-dtls">
                                    <h2 className="affiliate-title">Become An Offex Affiliate</h2>
                                    <p>
                                        A Business Finance consultant provides expert advice and
                                        assistance to businesses in managing their financial A Business
                                        Finance
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="affiliate-img float-start float-lg-end">
                                    <img
                                        src={Affilate_1}
                                        className="img-fluid"
                                        alt=""
                                    />
                                    <div className="affiliate-img-bg" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Affilate
